import React from 'react'
import { Grid } from '@mui/material'
import { PublicPageLayout } from '@/housefolios-components/PublicPages/shared'
import { usePublicMarketplacePage } from '@/hooks/usePublicMarketplacePage'
import MarketplaceViewToggle from '@/housefolios-components/PublicPages/components/MarketplaceViewToggle'
import MarketplaceContent from '@/housefolios-components/PublicPages/components/MarketplaceContent'
import PropertiesNav from '@/housefolios-components/Properties/PropertiesNav'
import { getPublicMarketplaceHeaderProps } from './publicMarketplaceHeader'

function PublicMarketplacePage(props) {
  const {
    // Data
    properties,
    count,
    currentPageProperties,
    marketPlaceData,
    unfilteredProperties,
    cursor,
    marketplaceUrl,
    subdomainParam,

    // State
    activeTab,
    showMenu,
    openAccept,
    openReject,
    isSidebarMenuOpen,
    ordering,
    page,
    selected,
    search,
    marketplaceSelected,

    // Loading states
    loadingMarketPlaceData,
    marketPlaceError,

    // Event handlers
    setActiveTab,
    handleMenu,
    setOpenAccept,
    setOpenReject,
    toggleSidebarMenu,
    selectAll,
    selectProperty,
    getSearchResults,
    getFilteredProperties,
    fetchMoreProperties,
    setOrdering,
    selectMarketplaceProperty,
    setMarketplaceSelected,
    handlePageChange,
    handleRequestSort,
    setSelected,
    setPage} = usePublicMarketplacePage(props)

  const headerProps = getPublicMarketplaceHeaderProps(props.marketplace)

  return (
    <PublicPageLayout
      title={headerProps.title}
      description={headerProps.description}
      icon={headerProps.icon}
      logoSrc={headerProps.logoSrc}
      logoAlt={headerProps.logoAlt}
      error={marketPlaceError}
      containerProps={{
        direction: 'column',
        alignItems: 'stretch',
        justifyContent: 'flex-start',
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
      }}
    >
      <Grid size={12} sx={{ width: '100%', maxWidth: '100%', minWidth: 0 }}>
        <MarketplaceViewToggle
          showMenu={showMenu}
          onToggle={() => setShowMenu(!showMenu)}
        />
      </Grid>

      <Grid size={12} sx={{ width: '100%', maxWidth: '100%', minWidth: 0 }}>
        <PropertiesNav
          handleMenu={handleMenu}
          showMenu={showMenu}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          search={search}
          getSearchResults={getSearchResults}
          getFilteredProperties={getFilteredProperties}
          selectAll={selectAll}
          selectProperty={selectProperty}
          properties={
            marketPlaceData?.marketplaceProperties?.properties
          }
          filteredProperties={properties}
          currentPageProperties={currentPageProperties}
          marketplace={marketplaceUrl || 'null'}
          ordering={ordering}
          setOrdering={setOrdering}
          shared
          public
        />
      </Grid>

      <Grid
        size={12}
        container
        direction="row"
        spacing={4}
        style={{ marginTop: 10 }}
        sx={{
          justifyContent: 'center',
          width: '100%',
          maxWidth: '100%',
          minWidth: 0,
        }}
      >
        <MarketplaceContent
          activeTab={activeTab}
          properties={properties}
          unfilteredProperties={unfilteredProperties}
          marketplace={marketplaceUrl}
          subdomainParam={subdomainParam}
          handleRequestSort={handleRequestSort}
          page={page}
          setPage={setPage}
          count={count}
          handlePageChange={handlePageChange}
          currentPageProperties={currentPageProperties}
          ordering={ordering}
          setOrdering={setOrdering}
          fetchMoreProperties={fetchMoreProperties}
          hasNextPage={
            marketPlaceData?.marketplaceProperties?.hasNextPage
          }
          cursor={cursor}
          sold={props.sold}
          loading={loadingMarketPlaceData}
        />
      </Grid>
    </PublicPageLayout>
  );
}

export default PublicMarketplacePage
